module.exports = __webpack_public_path__ + "img/no.v4.2.3.1776741939044.png";